// import React from "react";
// import Action from "../redux/Action";
// import { useDispatch, useSelector } from "react-redux";

// const PromoChargeInput = () => {
//   const dispatch = useDispatch();
//   const formValue = useSelector((state) => state.reducer.formValue);
//   const options = [
//     { label: "Admin", value: "ADMIN" },
//     { label: "Merchant", value: "MERCHANT" },
//     { label: "Admin & Merchant", value: "ADMIN_AND_MERCHANT" },
//     { label: "Shipper", value: "SHIPPER" },
//     { label: "Admin & Shipper", value: "ADMIN_AND_SHIPPER" },
//   ];
//   return (
//     <div className="flex flex-wrap flex-row items-center gap-5">
//       {options.map((option) => (
//         <div key={option.value} className="flex items-center">
//           <input
//             checked={formValue.promoCharge === option.value}
//             onChange={(e) => {
//               const name = e.target.name;
//               const value = e.target.value;
//               Action.handleFormChange(dispatch, {
//                 name,
//                 value,
//                 formValue: {
//                   ...formValue,
//                   discountAppliesTo: "",
//                   productCategory: "",
//                   merchant: null,
//                   shipmentProvider: null,
//                 },
//               });
//             }}
//             id={option.value}
//             type="radio"
//             value={option.value}
//             name="promoCharge"
//             className="w-4 h-4 text-gold-secondary bg-gray-100 border-gray-300 focus:ring-gray-primary"
//           />
//           <label
//             htmlFor={option.value}
//             className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
//           >
//             {option.label}
//           </label>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default PromoChargeInput;

import React from "react";
import Action from "../redux/Action";
import { useDispatch, useSelector } from "react-redux";

const PromoChargeInput = () => {
  const dispatch = useDispatch();
  const formValue = useSelector((state) => state.reducer.formValue);
  const options = [
    { label: "Admin", value: "ADMIN" },
    { label: "Merchant", value: "MERCHANT" },
    { label: "Admin & Merchant", value: "ADMIN_AND_MERCHANT" },
    { label: "Shipper", value: "SHIPPER" },
    { label: "Admin & Shipper", value: "ADMIN_AND_SHIPPER" },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    Action.handleFormChange(dispatch, {
      name,
      value,
      formValue: {
        ...formValue,
        discountAppliesTo: "",
        productCategory: "",
        merchant: null,
        shipmentProvider: null,
      },
    });
  };

  return (
    <div className="flex flex-wrap flex-row items-center gap-5">
      <select
        value={formValue.promoCharge || ""}
        onChange={handleChange}
        name="promoCharge"
        className="block w-full p-2 text-sm text-gray-900 rounded-xl border-white"
      >
        <option value="" disabled>
          Select an option
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default PromoChargeInput;
